/**
 * Created by dx.yang on 2017/2/13.
 */


import state from './state';
import actions from './actions';
import mutations from './mutations';

export default {
    state,
    actions,
    mutations
};


